import React from 'react';
import DnDContext from '../DnDContext';
import InitMessageDropAreaContainer from './InitMessageDropAreaContainer';
import Message from './Message';

import './MessageBoard.css'

// InitDropArea의 template props
const template_props = {
  minHeight: 15,
  index: 0
}
const LAST_MESSAGE_DROP_AREA_HEIGHT = 100

const MessageBoard = (props) => {
  const { 
    messages, 
    onDropMenuComponent, 
    onDropComponent, 
    isDragging, 
    editing, 
    messageActions,
    currentEditSlidePage,
    editing_message_index,
  } = props
  const { editingIndexes } = props
  const containerFunctions = {
    onDropMenuComponent : onDropMenuComponent,
    onDropComponent : onDropComponent,
  }

  const template_noMessageData = (props) => {
    return (
      template_InitMessageDropArea({
        ...template_props,
        ...props,
        minHeight: LAST_MESSAGE_DROP_AREA_HEIGHT,
        messageActions: messageActions,
        isDragging: isDragging,
        placeholder: true,
      })
    )
  }

  const template_messageData = (messages, conFunctions, isDragging, editingIndexes, editing, msgActions) => {
    const { 
      onDropMenuComponent,
      onDropComponent,
    } = conFunctions
    // const {
    //   editing_message_index
    // } = editingIndexes
  
    return (
      <React.Fragment>
        {template_InitMessageDropArea({...template_props, index: 0, messageActions: messageActions, isDragging: isDragging})}
        {
          messages && 
            messages.map((message, i, messages) => {
              const { rows, local_id } = message
              return (
                <React.Fragment key={local_id}>
                  <Message
                    key={local_id}
                    index={i}
                    rows={rows}
                    isDragging={isDragging}
                    editing={editing}
                    disable={!(editing_message_index === i) && editing}
                    currentEditMessage={messages}
                    currentEditSlidePage={currentEditSlidePage}
                    /**
                     * Acitons
                     */
                    onDropMenuComponent={onDropMenuComponent}
                    onDropComponent={onDropComponent}
                    // editingIndexes={editingIndexes} 
                    messageActions={msgActions} // Actions Object 로 전달
                    editing_message_index= {props.editing_message_index}
                    editing_row_index= {props.editing_row_index}
                    editing_slide_page_index= {props.editing_slide_page_index}
                  />
                  {template_InitMessageDropArea({
                    // ...template_props,
                    minHeight: messages.length === i+1 ? LAST_MESSAGE_DROP_AREA_HEIGHT : 15,
                    index: i+1,
                    messageActions: messageActions,
                    isDragging: isDragging,
                  })}      
                </React.Fragment>
              )
            })
        }
      </React.Fragment>
    )
  }

  const args = {
    
  }

  return (
    <div className="message-board">
      {
        messages ? // 메시지 데이터의 null, length === 0 여부 판단
          messages.length > 0 ? 
          template_messageData(messages, containerFunctions, isDragging, editingIndexes, editing, messageActions) :
          template_noMessageData() :
        template_noMessageData()
      }
    </div>
  )
}
  
const template_InitMessageDropArea = (props) => {
  console.log('props.placeholder :>> ', props.placeholder);
  return (
    <DnDContext>
      <InitMessageDropAreaContainer {...props}/>
    </DnDContext>
  )
}

export default MessageBoard